import React from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import AWS from "aws-sdk";
const MyEditor = ({ onChange, onBlur, name, value, isReadOnly }) => {
  function resizeImage(file, maxWidth, maxHeight) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function (event) {
        const img = new Image();
        img.src = event.target.result;
        img.onload = function () {
          let width = img.width;
          let height = img.height;

          if (width > height) {
            if (width > maxWidth) {
              height *= maxWidth / width;
              width = maxWidth;
            }
          } else {
            if (height > maxHeight) {
              width *= maxHeight / height;
              height = maxHeight;
            }
          }

          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");
          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0, width, height);

          canvas.toBlob((blob) => {
            resolve(new File([blob], file.name, { type: file.type }));
          }, file.type);
        };
      };
    });
  }

  function uploadAdapter(loader) {
    return {
      upload: () => {
        return new Promise((resolve, reject) => {
          const body = new FormData();
          loader.file.then(async (file) => {
            const resizedImage = await resizeImage(file, 800, 800); // Specify the desired maxWidth and maxHeight here

            let folder = "Editor";
            body.append("uploadImg", resizedImage);
            let TempFileName = resizedImage.name;

            const ext = TempFileName.substring(TempFileName.lastIndexOf("."));
            const timestamp = Date.now().toString();
            const random = Math.random().toString(36).slice(2);
            const fileName = timestamp + random + ext;

            AWS.config.update({
              region: process.env.REACT_APP_S3_BUCKET_REGION,
              accessKeyId: process.env.REACT_APP_S3_ACCESS_KEY_ID,
              secretAccessKey: process.env.REACT_APP_S3_SECRET_ACCESS_KEY,
            });
            const s3 = new AWS.S3();
            const params = {
              Bucket: process.env.REACT_APP_S3_BUCKET_NAME,
              Key: `${folder}/${fileName}`,
              Body: resizedImage,
              ACL: "public-read",
            };

            s3.upload(params, (err, data) => {
              if (err) {
                alert("Error uploading image:", err);
              } else {
                setTimeout(() => {
                  resolve({ default: data.Location });
                }, 100);
              }
            });
          });
        });
      },
    };
  }

  function uploadPlugin(editor) {
    editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
      return uploadAdapter(loader);
    };
  }
  return (
    <CKEditor
      editor={ClassicEditor}
      name={name}
      data={value}
      config={{
        extraPlugins: [uploadPlugin],
        removePlugins: [
          "blockQuote",
          "mediaEmbed",
          "insertTable",
          "tableColumn",
          "tableRow",
          "mergeTableCells",
          "imageTextAlternative",
          "ckfinder",
        ],
        toolbar: [
          "heading",
          "|",
          "bold",
          "italic",
          "|",
          "bulletedList",
          "numberedList",
          "|",
          "link",
          "imageUpload",
          "|",
          "undo",
          "redo",
        ],
        image: {
          toolbar: ["resizeImage:50"],
        },
      }}
      onChange={(event, editor) => {
        const data = editor.getData();
        onChange(data);
      }}
      onBlur={onBlur}
      disabled={isReadOnly === true ? true : false}
    />
  );
};

export default MyEditor;
